import React from 'react';
import { useNavigate } from 'react-router-dom';
import SPAButton from '../../shared/SPAButton';
import { ProgramLesson } from './types';

const StateViewCell = ({ lesson }: { lesson: ProgramLesson }) => {
  const navigate = useNavigate();

  return (
    <SPAButton
      aria-label={`Edit state-specific access for ${lesson.title}`}
      className="tw-whitespace-nowrap"
      size="xs"
      onClick={() => navigate(`lessons/${lesson.id}/states`)}
    >
      {/* No globe/world SVG in ui/Icon, so this keeps the legacy FA glyph. */}
      <i aria-hidden="true" className="fa fa-globe" />
      {lesson.states_selected}
    </SPAButton>
  );
};

export default StateViewCell;
